import React from "react";

//Custom Components
import AgencijePage from "UI/AppPage/AgencijePage";
import ResponsiveBox from "UI/Box/ResponsiveBox";
import AgencijePosebnePonudeTable from "Views/Agencije/PosebnePonude/AgencijePosebnePonudeTable";

const AgencijeEvaluacijaPage = React.memo((props) => {
  return (
    <AgencijePage>
      <ResponsiveBox fillHeight>
        <AgencijePosebnePonudeTable />
      </ResponsiveBox>
    </AgencijePage>
  );
});

export default AgencijeEvaluacijaPage;
